// User
export const SET_USER_ALL = 'SET_USER_ALL';
export const MODIFY_USER_INFO = 'MODIFY_USER_INFO';
export const MODIFY_USER_CONFIG = 'MODIFY_USER_CONFIG';
export const UPDATE_RESIZER_WF = 'UPDATE_RESIZER_WF';
export const UPDATE_RESIZER_HELP = 'UPDATE_RESIZER_HELP';
export const SET_USER_STANDINS = 'SET_USER_STANDINS';
export const MODIFY_SETTINGS_INFO = 'MODIFY_SETTINGS_INFO';
export const SET_USER_PREFERENCE = 'SET_USER_PREFERENCE';
export const SET_STANDIN_RESALTED = 'SET_STANDIN_RESALTED';

// Original Values
export const MODIFY_ORIGINAL_VALUES = 'MODIFY_ORIGINAL_VALUES';
export const MODIFY_SUBCAMPAIGN_ORIGINAL_VALUES = 'MODIFY_SUBCAMPAIGN_ORIGINAL_VALUES';

// Campaigns
export const MODYFY_CAMPAIGN = 'MODYFY_CAMPAIGN';
export const MODIFY_CAMPAIGN_HELP = 'MODIFY_CAMPAIGN_HELP';
export const UPDATE_CAMPAIGN_INFO = 'UPDATE_CAMPAIGN_INFO';
export const MODIFY_CAMPAIGN_INFO = 'MODIFY_CAMPAIGN_INFO';
export const MODIFY_CAMPAIGN_DESCRIPTION = 'MODIFY_CAMPAIGN_DESCRIPTION';
export const MODIFY_CAMPAIGN_ATTACHMENTS = 'MODIFY_CAMPAIGN_ATTACHMENTS';
export const ADD_CAMPAIGN_ATTACHMENTS = 'ADD_CAMPAIGN_ATTACHMENTS';
export const DELETE_CAMPAIGN_ATTACHMENT = 'DELETE_CAMPAIGN_ATTACHMENT';
export const TOGGLE_ATTACHMENT_FAVORITE = 'TOGGLE_ATTACHMENT_FAVORITE';
export const UPDATE_ATTACHMENT_FIELD = 'UPDATE_ATTACHMENT_FIELD';
export const ADD_AFTER_QMB_ATTACHMENTS = 'ADD_AFTER_QMB_ATTACHMENTS';
export const MODIFY_CAMPAIGN_CLASSIFICATION = 'MODIFY_CAMPAIGN_CLASSIFICATION';
export const MODIFY_CAMPAIGN_HARDWARE = 'MODIFY_CAMPAIGN_HARDWARE';
export const MODIFY_CAMPAIGN_SOFTWARE = 'MODIFY_CAMPAIGN_SOFTWARE';
export const MODIFY_CAMPAIGN_VEHICLES = 'MODIFY_CAMPAIGN_VEHICLES';
export const MODIFY_CAMPAIGN_RECIPIENTS = 'MODIFY_CAMPAIGN_RECIPIENTS';
export const MODIFY_CAMPAIGN_RISK_SCE_RELEVANCY = 'MODIFY_CAMPAIGN_RISK_SCE_RELEVANCY';
export const MODIFY_CAMPAIGN_SUMMARY = 'MODIFY_CAMPAIGN_SUMMARY';
export const MODIFY_CAMPAIGN_PLANTFEEDBACK = 'MODIFY_CAMPAIGN_PLANTFEEDBACK';
export const SET_CAMPAIGN_HISTORY = 'SET_CAMPAIGN_HISTORY';
export const TOGGLE_CAMPAIGN_HISTORY = 'TOGGLE_CAMPAIGN_HISTORY';
export const SET_CAMPAIGN_TRANSLATIONS = 'SET_CAMPAIGN_TRANSLATIONS';
export const SET_TRANSLATIONS = 'SET_TRANSLATIONS';
export const COPY_PLANT_ATTACHMENTS = 'COPY_PLANT_ATTACHMENTS';
export const RESET_CAMPAIGN = 'RESET_CAMPAIGN';
export const SET_CAMPAIGN_CHANGES = 'SET_CAMPAIGN_CHANGES';
export const SET_CAMPAIGN_SEARCH = 'SET_CAMPAIGN_SEARCH';
export const SET_CAMPAIGN_SEARCH_SELECTED_COINCIDENCE_FIELD_ID = 'SET_CAMPAIGN_SEARCH_SELECTED_COINCIDENCE_FIELD_ID';
export const SET_HIGHLIGHT_TAB = 'SET_HIGHLIGHT_TAB';

// SubCampaigns
export const MODYFY_SUBCAMPAIGN = 'MODYFY_SUBCAMPAIGN';
export const SET_SUBCAMPAIGN_SUMMARY = 'SET_SUBCAMPAIGN_SUMMARY';
export const MODIFY_SUBCAMPAIGN_FEEDBACK = 'MODIFY_SUBCAMPAIGN_FEEDBACK';
export const UPDATE_SUBCAMPAIGN_INFO = 'UPDATE_SUBCAMPAIGN_INFO';
export const SET_SUBCAMPAIGN_NOTES = 'SET_SUBCAMPAIGN_NOTES';
export const SET_SUBCAMPAING_NOTES_BY_TAB = 'SET_SUBCAMPAING_NOTES_BY_TAB';
export const MODIFY_SUBCAMPAIGN_DESCRIPTION_NOTES = 'MODIFY_SUBCAMPAIGN_DESCRIPTION_NOTES';
export const MODIFY_SUBCAMPAIGN_CLASSIFICATION_NOTES = 'MODIFY_SUBCAMPAIGN_CLASSIFICATION_NOTES';
export const MODIFY_SUBCAMPAIGN_HARDWARE_NOTES = 'MODIFY_SUBCAMPAIGN_HARDWARE_NOTES';
export const MODIFY_SUBCAMPAIGN_SOFTWARE_NOTES = 'MODIFY_SUBCAMPAIGN_SOFTWARE_NOTES';
export const MODIFY_SUBCAMPAIGN_VEHICLES_NOTES = 'MODIFY_SUBCAMPAIGN_VEHICLES_NOTES';
export const MODIFY_SUBCAMPAIGN_INFO = 'MODIFY_SUBCAMPAIGN_INFO';
export const SET_SUBCAMPAIGN_PLANTFEEDBACK = 'SET_SUBCAMPAIGN_PLANTFEEDBACK';
export const RESET_SUBCAMPAIGN = 'RESET_SUBCAMPAIGN';
export const SET_HIGHLIGHTED_FIELDS = 'SET_HIGHLIGHTED_FIELDS';

// Overview Filters
export const SET_OVERVIEW_FILTERS = 'SET_OVERVIEW_FILTERS';
export const SET_OVERVIEW_FILTERS_FOCUS = 'SET_OVERVIEW_FILTERS_FOCUS';

// Affected vehicles
export const MODIFY_CAMPAIGN_VEHICLES_ASSESSMENT = 'MODIFY_CAMPAIGN_VEHICLES_ASSESSMENT';
export const MODIFY_AFFECTED_VEHICLES_SERIES = 'MODIFY_AFFECTED_VEHICLES_SERIES';
export const MODIFY_AFFECTED_VEHICLES_VOLUMES = 'MODIFY_AFFECTED_VEHICLES_VOLUMES';
export const COPY_VEHICLES_MODEL_DESIGNATION = 'COPY_VEHICLES_MODEL_DESIGNATION';
export const COPY_AGGREGATE = 'COPY_AGGREGATE';
export const ADD_PLANT_ATTACHMENTS = 'ADD_PLANT_ATTACHMENTS';
export const DELETE_PLANT_ATTACHMENTS = 'DELETE_PLANT_ATTACHMENTS';
export const ADD_SELECTED_PLANT = 'ADD_SELECTED_PLANT';
export const SET_ONLY_PLANTS = 'SET_ONLY_PLANT';
export const SET_SELECTED_AFFECTED_VEHICLES = 'SET_SELECTED_AFFECTED_VEHICLES';
export const SET_AFFECTED_PLANTS = 'SET_AFFECTED_PLANTS';
export const SET_LIMITATION_PLANTS = 'SET_LIMITATION_PLANTS';
export const UPDATE_PLANT = 'UPDATE_PLANT';
export const SET_PENDING_VOLUMES = 'SET_PENDING_VOLUMES';

// Forms
export const SET_FORMS = 'SET_FORMS';
export const SET_DESCRIPTION_FORMS = 'SET_DESCRIPTION_FORMS';
export const SET_CLASSIFICATION_FORMS = 'SET_CLASSIFICATION_FORMS';
export const SET_AFFECTED_VEHICLES_FORMS = 'SET_AFFECTED_VEHICLES_FORMS';
export const SET_VOLUMES_FORMS = 'SET_VOLUMES_FORMS';
export const SET_RECIPIENTS_FORMS = 'SET_RECIPIENTS_FORMS';
export const SET_ATTACHMENTS_FORMS = 'SET_ATTACHMENTS_FORMS';
export const SET_SOFTWARE_FORMS = 'SET_SOFTWARE_FORMS';
export const SET_SUMMARY_FORMS = 'SET_SUMMARY_FORMS';
export const SET_SUBCRFEEDBACK_FORMS = 'SET_SUBCRFEEDBACK_FORMS';
export const SET_CAMPAIGN_STATUSES_FORMS = 'SET_CAMPAIGN_STATUSES_FORMS';
export const SET_SUBCAMPAIGN_STATUSES_FORMS = 'SET_SUBCAMPAIGN_STATUSES_FORMS';
export const SET_LANGUAGES_FORM = 'SET_LANGUAGES_FORM';
export const SET_PLANTS_FORM = 'SET_PLANTS_FORM';

// Validations
export const SET_VALIDATIONS = 'SET_VALIDATIONS';
export const SET_ACTIVE_VALIDATIONS_MIN = 'SET_ACTIVE_VALIDATIONS_MIN';
export const SET_DESCRIPTION_VALIDATIONS = 'SET_DESCRIPTION_VALIDATIONS';
export const SET_CLASSIFICATION_VALIDATIONS = 'SET_CLASSIFICATION_VALIDATIONS';
export const SET_SOFTWARE_VALIDATIONS = 'SET_SOFTWARE_VALIDATIONS';
export const SET_RECIPIENTS_VALIDATIONS = 'SET_RECIPIENTS_VALIDATIONS';
export const SET_AFFECTED_VEHICLES_VALIDATIONS = 'SET_AFFECTED_VEHICLES_VOLUMES_VALIDATIONS';
export const SET_AFFECTED_VEHICLES_VOLUMES = 'SET_AFFECTED_VEHICLES_VOLUMES';
export const SET_VOLUMES_AND_ORIGIN_CHANGE = 'SET_VOLUMES_AND_ORIGIN_CHANGE';
export const SET_VEHICLE_GROUPS = 'SET_VEHICLE_GROUPS';
export const SET_TRANSLATION_VALIDATIONS = 'SET_TRANSLATION_VALIDATIONS';
export const SET_VALIDATIONS_SUBCR = 'SET_VALIDATIONS_SUBCR';
export const SET_FEEDBACK_VALIDATIONS = 'SET_FEEDBACK_VALIDATIONS';

// Help
export const MODIFY_HELP = 'MODIFY_HELP';
export const MODIFY_HELP_SUMMARY = 'MODIFY_HELP_SUMMARY';
export const MODIFY_HELP_DESCRIPTION = 'MODIFY_HELP_DESCRIPTION';
export const MODIFY_HELP_ATTACHMENTS = 'MODIFY_HELP_ATTACHMENTS';
export const MODIFY_HELP_CLASSIFICATION = 'MODIFY_HELP_CLASSIFICATION';
export const MODIFY_HELP_HARDWARE = 'MODIFY_HELP_HARDWARE';
export const MODIFY_HELP_SOFTWARE = 'MODIFY_HELP_SOFTWARE';
export const MODIFY_HELP_VEHICLES = 'MODIFY_HELP_VEHICLES';
export const MODIFY_HELP_PARTIES = 'MODIFY_HELP_PARTIES';
export const MODIFY_HELP_RECIPIENTS = 'MODIFY_HELP_RECIPIENTS';
export const MODIFY_HELP_TRANSLATIONS = 'MODIFY_HELP_TRANSLATIONS';
export const MODIFY_HELP_AREA = 'MODIFY_HELP_AREA';
export const MODIFY_HELP_FEEDBACK = 'MODIFY_HELP_FEEDBACK';
export const MODIFY_HELP_SUMMARY_FEEDBACK = 'MODIFY_HELP_SUMMARY_FEEDBACK';
export const MODIFY_HELP_SUMMARY_PLANT_FEEDBACK = 'MODIFY_HELP_SUMMARY_PLANT_FEEDBACK';

// Workflow
export const MODIFY_WORKFLOW = 'MODIFY_WORKFLOW';
export const RESET_WORKFLOW = 'RESET_WORKFLOW';

// Header
export const SET_PLANT_NAME = 'SET_PLANT_NAME';
export const SET_HEADER_LANGUAGE = 'SET_HEADER_LANGUAGE';

// Params Configuration
export const SET_PARAMS_CONFIG = 'SET_PARAMS_CONFIG';
export const SET_PARAM_CONFIGURATION = 'SET_PARAM_CONFIGURATION';
